import { ApiErrorStatusCode, ErrorHandler } from 'lib-shared-auth';

import { verifyPermissions } from '../verifyPermissions';

export const forbiddenErrorHandler: ErrorHandler = {
  errorCode: ApiErrorStatusCode.Forbidden,
  handler: () => {
    verifyPermissions();
  },
};
